import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { AngularToolCall, ToolRenderer } from '@copilotkit/angular';
import { environment } from '../../environments/environment';
import { EmbedBridgeService } from '../embed-bridge.service';
import { HelpContextService } from './help-context.service';
import { resolveContactOptions } from './contact-options';

export interface ContactOptionsArgs extends Record<string, unknown> {
  subject: string;
}

const FALLBACK_SUPPORT_SUBJECT = 'PalChat: question needs a human';
const SPARE_PARTS_CASE_PATH = '/overview?create_new_case_with_type=spare_case';

/** Routes the visitor to a human, based on where they are and who they are. */
@Component({
  selector: 'pc-contact-options-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './contact-options-card.component.html',
  styleUrl: './contact-options-card.component.scss',
})
export class ContactOptionsCardComponent implements ToolRenderer<ContactOptionsArgs> {
  // eslint-disable-next-line paldesk-custom/signal-naming
  readonly toolCall = input.required<AngularToolCall<ContactOptionsArgs>>();

  protected readonly sparePartsCaseUrl =
    environment.supportPortalUrl + SPARE_PARTS_CASE_PATH;

  private readonly _embedBridge = inject(EmbedBridgeService);
  private readonly _helpContext = inject(HelpContextService);

  protected readonly $options = computed(() =>
    resolveContactOptions(this._helpContext.$context()),
  );

  protected openPaldeskSupport(): void {
    const subject = this.toolCall().args.subject?.trim();

    this._embedBridge.requestSupport(subject || FALLBACK_SUPPORT_SUBJECT);
  }
}
